"use strict";
import React from "react";
import _ from "underscore";
import CarrierName from "../carrier_name";
import CarrierInvoiceFormatter from "../../formatters/carrier_invoice";
import generalFormatter from "../../formatters/general";
function displayInvoiceNumber(invoice) {
  return invoice.source_invoice_number || "TBD";
}
function loadIdFormat(loadId) {
  if (loadId.includes("dummy")) {
    return "DRAFT LOAD";
  } else {
    return loadId;
  }
}
function CarrierInvoiceChooserAlreadyAssigned(props) {
  return /* @__PURE__ */ React.createElement(
    "h6",
    {
      "data-component": "CarrierInvoiceChooserAlreadyAssigned",
      className: "carrier-invoice-chooser__already-assigned"
    },
    "Documents are assigned to ",
    CarrierInvoiceFormatter.state(props.invoice),
    " ",
    /* @__PURE__ */ React.createElement(CarrierName, { carrierID: props.invoice.carrier_id }),
    " invoice #",
    displayInvoiceNumber(props.invoice),
    " ",
    props.additionalInvoiceInfo(props.invoice),
    " ",
    /* @__PURE__ */ React.createElement("a", { onClick: props.onRequestChange }, /* @__PURE__ */ React.createElement("i", { className: "fi-pencil" }))
  );
}
var CarrierInvoiceChooser = React.createClass({
  getInitialState: function() {
    return {};
  },
  buttonForInvoice: function(invoice) {
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        checked: this.props.selectedInvoice.id === invoice.id,
        onChange: _.partial(this.props.invoiceSelected, invoice),
        name: "carrier-invoice-chooser",
        className: "mousetrap"
      }
    );
  },
  componentWillReceiveProps: function() {
    this.setState({ editing: false });
  },
  render: function() {
    if (this.props.currentlyAssignedInvoice && this.props.selectedInvoice.id === this.props.initialInvoiceId && !this.state.editing) {
      return /* @__PURE__ */ React.createElement(
        CarrierInvoiceChooserAlreadyAssigned,
        {
          additionalInvoiceInfo: this.additionalInvoiceInfo,
          invoice: this.props.currentlyAssignedInvoice,
          loadID: this.props.loadID,
          onRequestChange: this.startEditing
        }
      );
    } else if (this.props.noInvoice) {
      return /* @__PURE__ */ React.createElement("div", { className: "carrier-invoice-chooser__wrapper" }, /* @__PURE__ */ React.createElement("h6", null, "Documents should be:"), /* @__PURE__ */ React.createElement("ul", { className: "carrier-invoice-chooser" }, /* @__PURE__ */ React.createElement("li", { className: "carrier-invoice-chooser-invoice" }, /* @__PURE__ */ React.createElement("label", { className: "carrier-invoice-chooser-invoice-label" }, /* @__PURE__ */ React.createElement("span", null, this.buttonForInvoice(this.props.noInvoice)), /* @__PURE__ */ React.createElement("span", null, " ", "assigned directly to the load ", this.additionalInvoiceInfo()))), _.map(this.props.invoicesForGroup, this.showInvoice)));
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "carrier-invoice-chooser__wrapper" }, /* @__PURE__ */ React.createElement("h6", null, "Documents should be:"), /* @__PURE__ */ React.createElement("ul", { className: "carrier-invoice-chooser" }, /* @__PURE__ */ React.createElement("li", { className: "carrier-invoice-chooser-invoice" }, /* @__PURE__ */ React.createElement("label", { className: "carrier-invoice-chooser-invoice-label" }, /* @__PURE__ */ React.createElement("span", null, this.buttonForInvoice(this.props.newInvoice)), /* @__PURE__ */ React.createElement("span", null, " ", "assigned to a new", " ", /* @__PURE__ */ React.createElement(CarrierName, { carrierID: this.props.carrierID }), " invoice", " ", this.additionalInvoiceInfo()))), _.map(this.props.invoicesForGroup, this.showInvoice)));
    }
  },
  startEditing: function() {
    this.setState({ editing: true });
  },
  // Documents should be assigned to a new D Graham Transport invoice - Load: 1094728
  // Documents should be left assigned to incomplete D Graham Transport invoice #TBD - Load: 1094728, date: 11/04/2015, amount: $650.00
  showInvoice: function(invoice) {
    const formattedState = CarrierInvoiceFormatter.state(invoice);
    let message = formattedState === "received" ? "assigned to a" : "assigned to an";
    if (this.props.currentlyAssignedInvoice && invoice.id === this.props.currentlyAssignedInvoice.id) {
      message = "left as assigned to";
    }
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        key: "invoice_li_" + invoice.id,
        className: "carrier-invoice-chooser-invoice"
      },
      /* @__PURE__ */ React.createElement("label", { className: "carrier-invoice-chooser-invoice-label" }, /* @__PURE__ */ React.createElement("span", null, this.buttonForInvoice(invoice)), /* @__PURE__ */ React.createElement("span", null, " ", message, " ", formattedState, " ", /* @__PURE__ */ React.createElement(CarrierName, { carrierID: this.props.carrierID }), " invoice #", invoice.source_invoice_number || "TBD", " ", this.additionalInvoiceInfo(invoice)))
    );
  },
  additionalInvoiceInfo: function(invoice) {
    var additionalInfo = "\u2013 Load:\xA0" + loadIdFormat(this.props.loadID);
    if (invoice && invoice.source_invoice_amount) {
      var amount = generalFormatter.currency(invoice.source_invoice_amount);
      additionalInfo += ", Amount:\xA0" + amount;
    }
    if (invoice && invoice.source_invoice_date) {
      var date = generalFormatter.shortDate(invoice.source_invoice_date);
      additionalInfo += ", Date:\xA0" + date;
    }
    return additionalInfo;
  }
});
export default CarrierInvoiceChooser;
